import { gql } from "@apollo/client";

export const PLAYER_SHIELD_TAGS_SUBSCRIPTION = gql`
    subscription PlayerShieldTagsSubscription {
        playerTags {
            id
            tagTier {
                tag
                tier
                tagName
                shieldValue
                subtitle
                unitName
            }
            createdAt
            updatedAt
            imageUrl
        }
    }
`;

export const ALL_SHIELD_TAGS_SUBSCRIPTION = gql`
    subscription AllShieldTagsSubscription {
        allTags {
            name
            slug
            milestones
            maxTiers
            shieldValues
            imageTemplate
            subtitle
            unitName
        }
    }
`;
